module.exports = __webpack_public_path__ + "media/images/flags/64/Cyprus-c76326285952dc027c03c4820cc97eec.png";